/* eslint-disable no-control-regex */
/* eslint-disable no-useless-escape */

import escapeStringRegexp from 'escape-string-regexp';
import TurndownService from 'turndown';
import { isArray, isEqual, isString, toString } from 'lodash';
import { numberToPercentage, isNumeric } from 'helpers';
import { charHide } from 'consts/data';

// const regexDetectATags = /<a[^>]*>.*?<\/a>/g;
const regexDetectATags = /<a href="#[^>]*>.*?<\/a>/g;
// const targetDetect = /target=".*[^>]"/g;
const openTagA = /<a/g;
const closeTagA = /<\/a/g;
const href = /href="#/g;

export const isASCII = (str) => {
  return /^[\x00-\x7F]*$/.test(str);
};

export const addSuffixToString = (string = '', suffix = '') => {
  return `${string}${suffix}`;
};

export const htmlToMarkdown = (html) => {
  const turndownService = new TurndownService();
  return turndownService.turndown(html);
};

export const isDecimalNumber = (number = 0) => {
  return toString(number).includes('.');
};

export const checkLimitDecimal = (number = 0, limit = 3) => {
  if (isDecimalNumber(number)) {
    if (toString(number).split('.')[1].length <= limit) {
      return true;
    }

    return false;
  }

  return true;
};

export const getIdTargetOnThisPage = (html = '') => {
  // ["#section1", "#section2", ...]
  const listId = (html.match(/href="(#.*?)"/g) || []).map((el) => {
    let tempString = el;
    tempString = tempString.replace(/href="/, '');
    tempString = tempString.replace(/\"/, '');

    return tempString;
  });
  return listId;
};

export const parseContentHTML = (html = '') => {
  if (isString(html)) {
    let tempHtml = html;
    const listDetect = html.match(regexDetectATags);
    if (listDetect) {
      listDetect.forEach((str) => {
        if (new RegExp(escapeStringRegexp(str)).test(tempHtml)) {
          tempHtml = tempHtml.replace(openTagA, '<div');
          tempHtml = tempHtml.replace(closeTagA, '</div');
          tempHtml = tempHtml.replace(href, 'id="');
        }
      });
    }

    return tempHtml;
  }
  return '';
};

export const localeNumber = (
  number,
  options = {
    maximumFractionDigits: 10,
  }
) => {
  return isNumeric(number)
    ? number.toLocaleString('en-US', { ...options, maximumFractionDigits: 10 })
    : 0;
};

export const convertLocaleToNumber = (localeNumber, locale = 'en-US') => {
  //* E.g: localeNumber = '123,456';
  if (isString(localeNumber)) {
    const { format } = new Intl.NumberFormat(locale);
    const [, decimalSign] = /^0(.)1$/.exec(format(0.1));
    return +localeNumber
      .replace(new RegExp(`[^${decimalSign}\\d]`, 'g'), '')
      .replace(decimalSign, '.');
  }

  return null;
};

export const addCommaToNumber = (number = 0) => {
  if (parseInt(`${number}`) >= 1000) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return number;
  }
};

export const capitalizeFirstLetter = (string = '') => {
  if (isString(string)) {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return '';
};

export const generateSpamScoreString = ({ color, index, value }) => {
  return `<span style="color: ${
    color !== undefined ? color : 'red'
  }"><strong>${index}:</strong> <strong>${numberToPercentage(value)}%</strong></span>`;
};

export const showOrHideString = ({ show = true, string = '' }) => {
  if (show) {
    return string;
  }

  if (isString(string)) {
    return string.replace(/./g, '*');
  }

  return charHide;
};

export const findLongestWord = (array = []) => {
  let longestWord = '';

  array.forEach(function (word) {
    if (word.length > longestWord.length) {
      longestWord = word;
    }
  });

  return longestWord;
};

export const uppercaseString = (string = '') => {
  return isString(string) ? string.toUpperCase() : '';
};

export const camelToPascal = (string = '') => {
  if (string === 'fName') return 'First Name';
  if (string === 'lName') return 'Last Name';
  if (string === 'creation_date') return 'Creation Date';
  if (isString(string)) {
    const newString = string[0].toUpperCase() + string.slice(1);
    const stringSplitted = newString?.match(/[A-Z][a-z]+/g);
    if (stringSplitted) {
      return stringSplitted.join(' ');
    }

    return '';
  }
  return '';
};

//* To convert string to number
export const convertValueStringToNumberToCompare = (arg) => {
  if (isString(arg)) {
    if (arg.includes(':')) {
      const nextNumber = Number(arg.replaceAll(':', ''));
      return nextNumber;
    }

    if (arg.includes('%')) {
      return Number(convertLocaleToNumber(arg.replace('%', '')));
    }

    if (arg.includes('$')) {
      return Number(convertLocaleToNumber(arg.replace('$', '')));
    }

    if (isNumeric(arg)) {
      return Number(arg);
    }
  }

  if (arg === null) {
    return -9999;
  }

  return arg;
};

export const convertHTMLToPlainText = (a) => {
  return a
    .replace(/<br\s*[\/]?>/gi, '\n')
    .replace(/<br>/gi, '\n')
    .replace(/<[^>]*>/gi, '')
    .replace(/<\/[^>]*>/gi, '')
    .replace(/&nbsp;|&#160;|\xa0/gi, ' ')
    .trim();
};

export const isEqualLowerString = (str1 = '', str2 = '') => {
  return isEqual(str1, str2);
};

export const isStrIncludeStr = (str1 = '', str2 = '') => {
  return str1?.toLowerCase().includes(str2?.toLowerCase());
};

export function snakeCaseToPascalCase(input) {
  if (typeof input !== 'string') {
    return '';
  }

  return input
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function hasHttpOrHttps(url) {
  if (typeof url !== 'string') {
    return false;
  }

  return /^https?:\/\//.test(url);
}

export function matchPath(pathname, pattern) {
  if (pathname === pattern) {
    return true;
  }

  const patternParts = pattern.split('/');
  const pathParts = pathname.split('/');

  if (patternParts.length !== pathParts.length) return false;

  for (let i = 0; i < patternParts.length; i++) {
    if (patternParts[i].startsWith(':')) continue;
    if (patternParts[i] !== pathParts[i]) return false;
  }

  return true;
}

export function transformLabelToFriendly(string) {
  if (isString(string)) {
    if (string.includes('_')) {
      return snakeCaseToPascalCase(string);
    }

    const firstChar = string[0];
    if (firstChar === string[0].toLowerCase()) {
      return camelToPascal(string);
    }
  }

  return string;
}

export function replaceAllCharTo(from, chars = [], to) {
  if (isString(from)) {
    chars.forEach((char) => {
      from = from.replaceAll(char, to);
    });
    return from;
  }

  return '';
}

export function validateBreakFormatAudio(input) {
  const regexCorrectFormatBreak = /<break\s+time="([^"]+)"\s*\/?>/m;
  const regexFindTheBreakTag = /<break\b[^>]*\/?>/gm;
  const matches = input.match(regexFindTheBreakTag);
  let valid = true;

  if (isArray(matches) && matches?.length > 0) {
    for (let i = 0; i < matches.length; i++) {
      const eachBreakTagFound = matches[i];
      const isCorrect = regexCorrectFormatBreak.test(eachBreakTagFound);
      if (isCorrect === false) {
        valid = false;
        break;
      }
    }
  }

  return { valid };
}
